import waybillReport from "./waybill-2022-12-12-14-33-55.pdf"
export const cancelOrder = (orderId) => {
    orderDetailJson?.data?.map((item) => {
        if (item.id === orderId) {
            item.showCancelButton = false
            item.showDelayButton = false
            item.trackingStatus = "PENDING_CANCELLATION"
            item.waybill = null
            item.status = "در انتظار لغو"
        }
    })
}


export const orderPageOneJson = {
    "current_page": 1,
    "data": [
        {
            "group_id": "c7a10921ldv",
            "payment_approach": "CREDIT",
            "created_at": 1670835808,
            "payment_type": "sender",
            "count": 1,
            "pickup_fee": 60000,
            "payable_price": 502000,
            "final_price": 562000,
            "providers": [
                {
                    "provider_count": 1,
                    "name": "ماهکس",
                    "code": "mahex",
                    "bulk_waybill": null,
                    "single_waybill": waybillReport,
                    "pickup": {
                        "from": 1670916600,
                        "to": 1670938200
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "۲۴ تا ۷۲ ساعت"
                    }
                }
            ]
        },
        {
            "group_id": "cgd10921cw6",
            "payment_approach": "CREDIT",
            "created_at": 1670842584,
            "payment_type": "sender",
            "count": 48,
            "pickup_fee": 0,
            "payable_price": 9917200,
            "final_price": 9917200,
            "providers": [
                {
                    "provider_count": 38,
                    "name": "اکوپیک",
                    "code": "ecopeyk",
                    "bulk_waybill": null,
                    "single_waybill": null,
                    "pickup": {
                        "from": 1670855400,
                        "to": 1670866200
                    },
                    "delivery": {
                        "from": 1670909400,
                        "to": 1670920200,
                        "type": "dateTime",
                        "id": "2022-12-13-1",
                        "title": null
                    }
                },
                {
                    "provider_count": 9,
                    "name": "لینک اکسپرس",
                    "code": "link",
                    "bulk_waybill": null,
                    "single_waybill": null,
                    "pickup": {
                        "from": 1670909400,
                        "to": 1670923800
                    },
                    "delivery": {
                        "from": 1670931000,
                        "to": 1670949000,
                        "type": "dateTime",
                        "id": "2022-12-13-2",
                        "title": null
                    }
                },
                {
                    "provider_count": 1,
                    "name": "اسپید",
                    "code": "speed",
                    "bulk_waybill": null,
                    "single_waybill": waybillReport,
                    "pickup": {
                        "from": 1670909400,
                        "to": 1670927400
                    },
                    "delivery": {
                        "from": 1670931000,
                        "to": 1670952600,
                        "type": "dateTime",
                        "id": "2022-12-13-2",
                        "title": null
                    }
                }
            ]
        },
        {
            "group_id": "cj410921cl0",
            "payment_approach": "CREDIT",
            "created_at": 1670836115,
            "payment_type": "sender",
            "count": 2,
            "pickup_fee": 60000,
            "payable_price": 734000,
            "final_price": 794000,
            "providers": [
                {
                    "provider_count": 2,
                    "name": "ندکس",
                    "code": "nedex",
                    "bulk_waybill": "https://portal.podro.com/api/orders/make/bulk/pdf?groupId=cj410921cl0&provider=nedex",
                    "single_waybill": null,
                    "pickup": {
                        "from": 1670841000,
                        "to": 1670859000
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "۲۴ تا ۷۲ ساعت"
                    }
                }
            ]
        },
        {
            "group_id": "cq310919r1e",
            "payment_approach": "CREDIT",
            "created_at": 1670835707,
            "payment_type": "sender",
            "count": 16,
            "pickup_fee": 0,
            "payable_price": 4800000,
            "final_price": 4800000,
            "providers": [
                {
                    "provider_count": 16,
                    "name": "پادرو اکسپرس",
                    "code": "podex",
                    "bulk_waybill": "https://portal.podro.com/api/orders/make/bulk/pdf?groupId=cq310919r1e&provider=podex",
                    "single_waybill": null,
                    "pickup": {
                        "from": 1670923800,
                        "to": 1670927400
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "پنج ساعت بعد از جمع آوری"
                    }
                }
            ]
        },
        {
            "group_id": "c4b109164vx",
            "payment_approach": "CREDIT",
            "created_at": 1670656043,
            "payment_type": "sender",
            "count": 1,
            "pickup_fee": 0,
            "payable_price": 300000,
            "final_price": 300000,
            "providers": [
                {
                    "provider_count": 1,
                    "name": "پادرو اکسپرس",
                    "code": "podex",
                    "bulk_waybill": null,
                    "single_waybill": waybillReport,
                    "pickup": {
                        "from": 1670664600,
                        "to": 1670668200
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "پنج ساعت بعد از جمع آوری"
                    }
                }
            ]
        },
        {
            "group_id": "cc5109161cj",
            "payment_approach": "CREDIT",
            "created_at": 1670421214,
            "payment_type": "sender",
            "count": 2,
            "pickup_fee": 60000,
            "payable_price": 684000,
            "final_price": 744000,
            "providers": [
                {
                    "provider_count": 2,
                    "name": "ندکس",
                    "code": "nedex",
                    "bulk_waybill": "https://portal.podro.com/api/orders/make/bulk/pdf?groupId=cc5109161cj&provider=nedex",
                    "single_waybill": null,
                    "pickup": {
                        "from": 1670650200,
                        "to": 1670668200
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "۲۴ تا ۷۲ ساعت"
                    }
                }
            ]
        },
        {
            "group_id": "cug109165ln",
            "payment_approach": "CREDIT",
            "created_at": 1670421165,
            "payment_type": "sender",
            "count": 1,
            "pickup_fee": 60000,
            "payable_price": 502000,
            "final_price": 562000,
            "providers": [
                {
                    "provider_count": 1,
                    "name": "ماهکس",
                    "code": "mahex",
                    "bulk_waybill": null,
                    "single_waybill": waybillReport,
                    "pickup": {
                        "from": 1670657400,
                        "to": 1670679000
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "۲۴ تا ۷۲ ساعت"
                    }
                }
            ]
        },
        {
            "group_id": "ctm109021zm",
            "payment_approach": "CREDIT",
            "created_at": 1670420881,
            "payment_type": "sender",
            "count": 15,
            "pickup_fee": 0,
            "payable_price": 4500000,
            "final_price": 4500000,
            "providers": [
                {
                    "provider_count": 15,
                    "name": "پادرو اکسپرس",
                    "code": "podex",
                    "bulk_waybill": "https://portal.podro.com/api/orders/make/bulk/pdf?groupId=ctm109021zm&provider=podex",
                    "single_waybill": null,
                    "pickup": {
                        "from": 1670664600,
                        "to": 1670668200
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "پنج ساعت بعد از جمع آوری"
                    }
                }
            ]
        },
        {
            "group_id": "czt1081586d",
            "payment_approach": "CREDIT",
            "created_at": 1669208067,
            "payment_type": "sender",
            "count": 9,
            "pickup_fee": 59994,
            "payable_price": 1862481,
            "final_price": 1922475,
            "providers": [
                {
                    "provider_count": 4,
                    "name": "لینک اکسپرس",
                    "code": "link",
                    "bulk_waybill": null,
                    "single_waybill": null,
                    "pickup": {
                        "from": 1669267800,
                        "to": 1669282200
                    },
                    "delivery": {
                        "from": 1669289400,
                        "to": 1669307400,
                        "type": "dateTime",
                        "id": "2022-11-24-2",
                        "title": null
                    }
                },
                {
                    "provider_count": 5,
                    "name": "شرکت ملی پست (پیشتاز)",
                    "code": "post",
                    "bulk_waybill": "https://portal.podro.com/api/orders/make/bulk/pdf?groupId=czt1081586d&provider=post",
                    "single_waybill": null,
                    "pickup": {
                        "from": 1669267800,
                        "to": 1669275000
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "۲۴ تا ۷۲ ساعت"
                    }
                }
            ]
        },
        {
            "group_id": "cxq10815kil",
            "payment_approach": "CREDIT",
            "created_at": 1667732957,
            "payment_type": "sender",
            "count": 2,
            "pickup_fee": 60000,
            "payable_price": 451008,
            "final_price": 511008,
            "providers": [
                {
                    "provider_count": 1,
                    "name": "شرکت ملی پست (پیشتاز)",
                    "code": "post",
                    "bulk_waybill": null,
                    "single_waybill": null,
                    "pickup": {
                        "from": 1667799000,
                        "to": 1667817000
                    },
                    "delivery": {
                        "from": null,
                        "to": null,
                        "type": "string",
                        "id": null,
                        "title": "۲۴ تا ۷۲ ساعت"
                    }
                },
                {
                    "provider_count": 1,
                    "name": "لینک اکسپرس",
                    "code": "link",
                    "bulk_waybill": null,
                    "single_waybill": null,
                    "pickup": {
                        "from": 1667820600,
                        "to": 1667838600
                    },
                    "delivery": {
                        "from": 1667885400,
                        "to": 1667903400,
                        "type": "dateTime",
                        "id": "2022-11-08-1",
                        "title": null
                    }
                }
            ]
        }
    ],
    "first_page_url": "/?page=1",
    "from": 1,
    "last_page": 4,
    "last_page_url": "/?page=4",
    "next_page_url": "/?page=2",
    "path": "/",
    "per_page": 10,
    "prev_page_url": null,
    "to": 10,
    "total": 31
}
export const orderDetailJson ={
    "data": [
        {
            "discount": 0,
            "id": "41eab71c-59e2-4bfd-96ce-1769eb3acb31",
            "invoice": {
                "finalPrice": 235000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "lnk010921fmi",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 235000,
            "receiver": {
                "address": "امل-کمانگر کلا هراز پی لاله 22  پلاک 407 واحد 1",
                "cityCode": "2301",
                "firstName": "ایمان اشتریان",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670931000,
                    "to": 1670949000,
                    "type": "dateTime",
                    "id": "2022-12-13-2",
                    "title": null
                },
                "pickup": {
                    "from": 1670909400,
                    "to": 1670923800
                },
                "providerName": "لینک اکسپرس"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 235000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=41eab71c-59e2-4bfd-96ce-1769eb3acb31"
        },
        {
            "discount": 0,
            "id": "b607bb72-ddeb-4bec-bd96-a85b8517b191",
            "invoice": {
                "finalPrice": 199000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "epk010921gnt",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 199000,
            "receiver": {
                "address": "بولوارهاشمیه79 پلاک 3 واحد 4",
                "cityCode": "0916",
                "firstName": "میلاد قلیزاد",
                "latitude": "35.616863",
                "longitude": "51.397217",
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": "35.713451",
                "longitude": "51.449278",
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "id": "2022-12-13-1",
                    "to": 1670920200,
                    "from": 1670909400,
                    "type": "dateTime",
                    "title": null
                },
                "pickup": {
                    "from": 1670855400,
                    "to": 1670866200
                },
                "providerName": "اکوپیک"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 199000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=b607bb72-ddeb-4bec-bd96-a85b8517b191"
        },
        {
            "discount": 0,
            "id": "ba84c907-fa7d-4f1c-8516-1294f95e6ad5",
            "invoice": {
                "finalPrice": 235000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "lnk0109216zc",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 235000,
            "receiver": {
                "address": "شهرک مسعودیه خیابان ابومسلم خراسانی کوچه مردانی پلاک 18 واحد 2",
                "cityCode": "2301",
                "firstName": "هادی تست",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670931000,
                    "to": 1670949000,
                    "type": "dateTime",
                    "id": "2022-12-13-2",
                    "title": null
                },
                "pickup": {
                    "from": 1670909400,
                    "to": 1670923800
                },
                "providerName": "لینک اکسپرس"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 235000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=ba84c907-fa7d-4f1c-8516-1294f95e6ad5"
        },
        {
            "discount": 0,
            "id": "61c7f4f0-800c-4c4a-a4ad-a9da0af0b8e9",
            "invoice": {
                "finalPrice": 199000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "epk010921wks",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 199000,
            "receiver": {
                "address": "قرچک-خیابان اصلی ابتدای خیابان خلیج فارس جنب باطری سازی جعفر ساختمان گل سرخ واحد7 پلاک  واحد 7",
                "cityCode": "2321",
                "firstName": "سیما ملک",
                "latitude": "35.420162",
                "longitude": "51.571973",
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": "35.713451",
                "longitude": "51.449278",
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "id": "2022-12-13-1",
                    "to": 1670920200,
                    "from": 1670909400,
                    "type": "dateTime",
                    "title": null
                },
                "pickup": {
                    "from": 1670855400,
                    "to": 1670866200
                },
                "providerName": "اکوپیک"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "درحال پردازش",
            "totalPrice": 199000,
            "trackingStatus": "IN_PROGRESS",
            "waybill": null
        },
        {
            "discount": 0,
            "id": "701f5a24-741b-4c8e-8552-c4ad881c789b",
            "invoice": {
                "finalPrice": 235000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "lnk010921xm7",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 235000,
            "receiver": {
                "address": "مرند-خیابان شهیدرجایی کوچه اسلام آباد کوی لاله غربی  پلاک 38 واحد 1",
                "cityCode": "2301",
                "firstName": "فاطمه هاشمی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670931000,
                    "to": 1670949000,
                    "type": "dateTime",
                    "id": "2022-12-13-2",
                    "title": null
                },
                "pickup": {
                    "from": 1670909400,
                    "to": 1670923800
                },
                "providerName": "لینک اکسپرس"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 235000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=701f5a24-741b-4c8e-8552-c4ad881c789b"
        },
        {
            "discount": 0,
            "id": "7b4a1e14-5d2b-4908-98a9-8b3223ace487",
            "invoice": {
                "finalPrice": 199000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "epk0109212gf",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 199000,
            "receiver": {
                "address": "کیش-کیش فجر ششم  پلاک 129 واحد 4",
                "cityCode": "2202",
                "firstName": "نساء نوشاد",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670909400,
                    "to": 1670920200,
                    "type": "dateTime",
                    "id": "2022-12-13-1",
                    "title": null
                },
                "pickup": {
                    "from": 1670855400,
                    "to": 1670866200
                },
                "providerName": "اکوپیک"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 199000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=7b4a1e14-5d2b-4908-98a9-8b3223ace487"
        },
        {
            "discount": 0,
            "id": "2e25992b-97fb-4baf-b756-5f8c42d53629",
            "invoice": {
                "finalPrice": 235000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "lnk010921stw",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 235000,
            "receiver": {
                "address": "بلوار جمهوری روبروی بلوار‌حمزه بانک پاسارگاد  پلاک 1 واحد 1",
                "cityCode": "2301",
                "firstName": "کوثر لشکری ابادی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670931000,
                    "to": 1670949000,
                    "type": "dateTime",
                    "id": "2022-12-13-2",
                    "title": null
                },
                "pickup": {
                    "from": 1670909400,
                    "to": 1670923800
                },
                "providerName": "لینک اکسپرس"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 235000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=2e25992b-97fb-4baf-b756-5f8c42d53629"
        },
        {
            "discount": 0,
            "id": "14c8d90f-6bd6-4202-9847-93b8b3e92d8c",
            "invoice": {
                "finalPrice": 199000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "epk010921t8p",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 199000,
            "receiver": {
                "address": "اسلام ابادغرب-میدان هدایت بلوار معلم کوچه شهید هدایت مرادی  پلاک 16 واحد 2",
                "cityCode": "0502",
                "firstName": "تست علیانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670909400,
                    "to": 1670920200,
                    "type": "dateTime",
                    "id": "2022-12-13-1",
                    "title": null
                },
                "pickup": {
                    "from": 1670855400,
                    "to": 1670866200
                },
                "providerName": "اکوپیک"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 199000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=14c8d90f-6bd6-4202-9847-93b8b3e92d8c"
        },
        {
            "discount": 0,
            "id": "342e8d45-1c0e-4396-9acf-afcd212bebf9",
            "invoice": {
                "finalPrice": 199000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "epk010921pol",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 199000,
            "receiver": {
                "address": "قم .بنیاد خیابان شهید مطهری کوچه 2 طبقه دوم پلاک 2 واحد طبقه دوم",
                "cityCode": "2501",
                "firstName": "عرفان وفا",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670909400,
                    "to": 1670920200,
                    "type": "dateTime",
                    "id": "2022-12-13-1",
                    "title": null
                },
                "pickup": {
                    "from": 1670855400,
                    "to": 1670866200
                },
                "providerName": "اکوپیک"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 199000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=342e8d45-1c0e-4396-9acf-afcd212bebf9"
        },
        {
            "discount": 0,
            "id": "2c0d3490-ea13-408c-b8df-9737fc792711",
            "invoice": {
                "finalPrice": 235000,
                "pickupFee": 0
            },
            "markup": "",
            "orderCode": "lnk010921h6g",
            "parcels": [
                {
                    "content": "کارت",
                    "value": 100000,
                    "weight": 200
                }
            ],
            "payablePrice": 235000,
            "receiver": {
                "address": "ری-حمزه آباد خ محمودی جنب مسجد موسی بن جعفر پلاک 100 واحد 2",
                "cityCode": "2301",
                "firstName": "معصومه عافیت",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09121111111",
                "postalCode": "1111111111"
            },
            "sender": {
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "cityCode": "2301",
                "firstName": "محدثه ایرانی",
                "latitude": null,
                "longitude": null,
                "nationalCode": "",
                "phone": "09300183181",
                "postalCode": "1921481221"
            },
            "shipment": {
                "delivery": {
                    "from": 1670931000,
                    "to": 1670949000,
                    "type": "dateTime",
                    "id": "2022-12-13-2",
                    "title": null
                },
                "pickup": {
                    "from": 1670909400,
                    "to": 1670923800
                },
                "providerName": "لینک اکسپرس"
            },
            "showCancelButton": true,
            "showDelayButton": false,
            "status": "ثبت اولیه",
            "totalPrice": 235000,
            "trackingStatus": "PROVIDER_SEEN",
            "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf?orderId=2c0d3490-ea13-408c-b8df-9737fc792711"
        }
    ],
    "links": {
        "first": "http://portal.podro.com/api/orders/cgd10921cw6?page=1",
        "last": "http://portal.podro.com/api/orders/cgd10921cw6?page=5",
        "prev": null,
        "next": "http://portal.podro.com/api/orders/cgd10921cw6?page=2"
    },
    "meta": {
        "current_page": 1,
        "from": 1,
        "last_page": 5,
        "path": "http://portal.podro.com/api/orders/cgd10921cw6",
        "per_page": 10,
        "to": 10,
        "total": 48,
        "orderCount": 10,
        "createdAt": 1670842596,
        "groupId": "cgd10921cw6",
        "payer": "sender",
        "method": "CREDIT",
        "count": 10,
        "currentPage": 1,
        "lastPage": 5,
        "nextPageUrl": "http://portal.podro.com/api/orders/cgd10921cw6?page=2",
        "pageSize": 10,
        "waybill": "https://portal.podro.com/api/orders/cgd10921cw6/pdf"
    }
}
export const orderReportPostJson = {
    "message": "ساخت گزارش به اتمام رسید . به محض تولید آن لینک دانلود در پنل برای شما قرار داده می شود"
}